import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {EsriMapViewComponent} from '../components/esri-map-view/esri-map-view.component';
import {EsriSceneViewComponent} from '../components/esri-scene-view/esri-scene-view.component';


const routes: Routes = [
  {
    path: '2d-view',
    component: EsriMapViewComponent,
    children: [
      {
        path: 'help',
        loadChildren: () => import('./help-page.module').then(mod => mod.HelpPageModule)
      }
    ]
  },
  {
    path: '3d-view',
    component: EsriSceneViewComponent,
    children: [
      {
        path: 'help',
        loadChildren: () => import('./help-page.module').then(mod => mod.HelpPageModule)
      }
    ]
  },
  {path: '**', redirectTo: '2d-view'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
